// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../../src/environment.d.ts" />

import { TranslateService } from 'Public_old/src/app/Common/Services/translate.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SpaContext } from '../Classes/spacontext';
import { SpaLogger } from '../Common/Classes/Global/spalogger.class';
import { GeneralService } from '../Services/general.service';
import { SpaEventService } from '../Services/spaEvents.service';
import { SecurityLevel } from '../Constants/securityLevel';
import { AuthContextService } from '../Services/authContext.service';
import { LicenceHolderService } from '@services/licence_holder.service';

import { LocationSelectorService } from '@services/location_selector.service';
import { IdpUrlRedirectStorageService } from '@public/src/application/idp_url_redirect_storage.service';
import { sharedResolution } from '../../../src/shared_resolution';
import { HostingService } from '@application/hosting.service';
import { UniversalConfig } from '@application/universal_config.service';

@Injectable()
export class ViewGuard implements CanActivate {
	constructor(
		private _router: Router,
		public _spaContext: SpaContext,
		private spaLogger: SpaLogger,
		private _generalService: GeneralService,
		private _spaEventService: SpaEventService,
		private translateService: TranslateService,
		private authContextService: AuthContextService,
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | Observable<boolean> | boolean {
		const locationSelectorService = sharedResolution.resolve(LocationSelectorService);
		const licenceHolderService = sharedResolution.resolve(LicenceHolderService);

		if (
			(this._spaContext.unitConfig.LicenceHolder.HasMultipleLandingPages &&
				licenceHolderService.rootUnitId === locationSelectorService.entrance?.id &&
				typeof route.data['availibleToNonEntrance'] === 'undefined') ||
			route.data['availibleToNonEntrance'] === false
		) {
			return false;
		}

		if (window.__visiba_feature_flags__['CareExperience.PW.Idp']) {
			// noop
		} else {
			if (this._spaContext.documentSigningPending) {
				return Observable.create((observer) => {
					this._spaEventService.onDocumentsSigningCompleted.subscribe(() => {
						observer.next(true);
						observer.complete();
					});
					this._spaEventService.onDocumentsSigningAborted.subscribe(() => {
						observer.next(route.data['access'] === SecurityLevel.Public);
						observer.complete();
						if (route.data['access'] !== SecurityLevel.Public) {
							window.setTimeout(() => {
								document.location.reload();
							}, 500);
						}
					});
				});
			}
		}

		let result = false;
		switch (route.data['access']) {
			case SecurityLevel.Public:
				result = true;
				break;
			case SecurityLevel.Developer:
				result = µ.isDevelopment;
				break;
			case SecurityLevel.Client:
				result = this.authContextService.isClient();
				break;
			case SecurityLevel.ClientOrOutsider:
				result = this.authContextService.isClient() || this.authContextService.isOutsider();
				break;
			case SecurityLevel.Outsider:
				result = this.authContextService.isOutsider();
				break;
			case SecurityLevel.Resource:
				result = this.authContextService.isResource();
				break;
			case SecurityLevel.ResourceOrClient:
				result = this.authContextService.isResource() || this.authContextService.isClient();
				break;
			case SecurityLevel.ResourceOrOutsider:
				result = this.authContextService.isResource() || this.authContextService.isOutsider();
				break;
			case SecurityLevel.ResourceOrClientOrOutsider:
				result = this.authContextService.isResource() || this.authContextService.isClient() || this.authContextService.isOutsider();
				break;
			default:
				result = false; // Should not ever get here!
		}

		// If the CareExperience.PW.Idp feature flag is enabled, we will skip the rest of this function and return immediately.
		// This allows us to easily disable this routing logic by setting the flag to true in our configuration.
		if (__visiba_feature_flags__['CareExperience.PW.Idp']) {
			if (!result) {
				sharedResolution.resolve(IdpUrlRedirectStorageService).setRedirectPath(state.url);
			}
		}

		if (!result) {
			const ticket = (route.params['ticket'] ?? route.params['callTicket'])?.split('?')[0];

			// ## Check user type from appointment callticket
			if (state.url.indexOf('/appointment/') !== -1 && ticket != null) {
				return new Promise((resolve) => {
					this._generalService.getAppointmentAccessInfo(ticket).subscribe(
						(response) => {
							if (response) {
								if (response.data.ResourceId !== null) {
									const hostingService = sharedResolution.resolve(HostingService);
									const universalConfig = sharedResolution.resolve(UniversalConfig);

									const returnUrl = encodeURIComponent(`${hostingService.location}${state.url}`);
									const url = `/o${universalConfig.alias}/sign-in;returnUrl=${returnUrl}`.replace('//', '/');

									window.location.href = url;
								} else if (response.data.OutsiderId && response.data.AuthenticationMethod) {
									this._spaEventService.onSignInRequired.emit({
										target: state.url,
										reason: this.translateService.get('LicenceHolder.Component.SignIn.Phrase.ReasonGuestAuth'),
										callticket: ticket,
										authMethod: response.data.AuthenticationMethod,
									});
								} else {
									this._spaEventService.onSignInRequired.emit({ target: state.url });
								}
								resolve(false);
							}
						},
						() => {
							this._spaEventService.onSignInRequired.emit({ target: state.url });
							resolve(false);
						},
					);
				});
			}

			this._spaEventService.onSignInRequired.emit({ target: state.url, leave: false });
		}

		return result;
	}
}
